export const EVENT_TYPES = {
  community_day:  'Community Day',
  raid_day:       'Raid-Tag',
  max_day:        'Dyna-Tag',
  raid_hour:      'Raid-Stunde',
  spotlight_hour: 'Rampenlicht-Stunde',
  season:         'Saison',
  research:       'Forschung',
  special:        'Spezial',
  other:          'Sonstiges',
};

export const POKEMON_ROLES = {
  featured:        'Im Fokus',
  raid_boss:       'Raid-Boss',
  increased_spawn: 'Häufigeres Spawn',
  egg:             'Aus Eiern',
  research_reward: 'Forschungsbelohnung',
};

const dateFmt = new Intl.DateTimeFormat('de-DE', {
  day: '2-digit', month: 'short', hour: '2-digit', minute: '2-digit',
});
const dayFmt = new Intl.DateTimeFormat('de-DE', { day: '2-digit', month: 'long', year: 'numeric' });

export const parseDate = (value) => new Date(String(value).replace(' ', 'T'));

export function formatRange(startsAt, endsAt) {
  const start = parseDate(startsAt);
  const end = parseDate(endsAt);
  const sameDay = start.toDateString() === end.toDateString();

  if (sameDay) {
    const time = new Intl.DateTimeFormat('de-DE', { hour: '2-digit', minute: '2-digit' });
    return `${dayFmt.format(start)}, ${time.format(start)}–${time.format(end)} Uhr`;
  }
  return `${dateFmt.format(start)} – ${dateFmt.format(end)}`;
}

/** 'live' während des Events, 'upcoming' davor, 'past' danach. */
export function eventStatus(event, now = new Date()) {
  const start = parseDate(event.startsAt);
  const end = parseDate(event.endsAt);
  if (now < start) return 'upcoming';
  if (now > end) return 'past';
  return 'live';
}

/** Grobe, menschliche Angabe wie "in 3 Tagen". */
export function relativeLabel(event, now = new Date()) {
  const status = eventStatus(event, now);
  if (status === 'live') return 'Läuft gerade';
  if (status === 'past') return 'Vorbei';

  const diffMs = parseDate(event.startsAt) - now;
  const hours = Math.round(diffMs / 3.6e6);
  if (hours < 1) return 'Startet gleich';
  if (hours < 24) return `In ${hours} Std.`;
  const days = Math.round(hours / 24);
  return days === 1 ? 'Morgen' : `In ${days} Tagen`;
}

export const typeColor = (type) =>
  `var(--t-${String(type).toLowerCase().replace(/[^a-z]/g, '')}, var(--t-normal))`;

export const eventColor = (event) =>
  event.accentColor || `var(--ev-${event.eventType}, var(--ev-other))`;
